import loadable from '@loadable/component';

export const TrdSiteWrapper = loadable(
  () => import(/* webpackChunkName: "trd-site" */ './TrdSiteWrapper'),
);
